import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function EducationNotes({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">{t("Notes")}</legend>
      <input
        type="text"
        onChange={onChange}
        value={searchObject.notes || ""}
        name="notes"
        className="form-control fontsize-legend"
      />
    </div>
  );
}
